/*
 * @Author: chengyu
 * @Date: 2022-10-18 16:19:45
 * @Description: 日志方法
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getDebug } from '../config';
var projectName = 'MapApi';
export function mapLog(message, content) {
    if (content === void 0) { content = []; }
    try {
        if (getDebug()) {
            console.log.apply(console, __spreadArray(["[".concat(projectName, "] ").concat(message)], content, false));
        }
    }
    catch (e) {
        console.error(e);
    }
}
export function mapInfo(message, content) {
    if (content === void 0) { content = []; }
    try {
        if (getDebug()) {
            console.info.apply(console, __spreadArray(["[".concat(projectName, " info] ").concat(message)], content, false));
        }
    }
    catch (e) {
        console.error(e);
    }
}
export function mapWarn(message, content) {
    if (content === void 0) { content = []; }
    try {
        if (getDebug()) {
            console.warn.apply(console, __spreadArray(["[".concat(projectName, " warn] ").concat(message)], content, false));
        }
    }
    catch (e) {
        console.error(e);
    }
}
export function mapError(message, error) {
    try {
        console.error("[".concat(projectName, " error] ").concat(message), error);
    }
    catch (e) {
        console.error(e);
        // nothing
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvdXRpbHMvbG9nZ2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7Ozs7Ozs7Ozs7QUFFSCxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRXJDLElBQU0sV0FBVyxHQUFHLFFBQVEsQ0FBQztBQUU3QixNQUFNLFVBQVUsTUFBTSxDQUFDLE9BQWUsRUFBRSxPQUFtQjtJQUFuQix3QkFBQSxFQUFBLFlBQW1CO0lBQ3pELElBQUk7UUFDRixJQUFJLFFBQVEsRUFBRSxFQUFFO1lBQ2QsT0FBTyxDQUFDLEdBQUcsT0FBWCxPQUFPLGlCQUFLLFdBQUksV0FBVyxlQUFLLE9BQU8sQ0FBRSxHQUFLLE9BQU8sVUFBRTtTQUN4RDtLQUNGO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2xCO0FBQ0gsQ0FBQztBQUVELE1BQU0sVUFBVSxPQUFPLENBQUMsT0FBZSxFQUFFLE9BQW1CO0lBQW5CLHdCQUFBLEVBQUEsWUFBbUI7SUFDMUQsSUFBSTtRQUNGLElBQUksUUFBUSxFQUFFLEVBQUU7WUFDZCxPQUFPLENBQUMsSUFBSSxPQUFaLE9BQU8saUJBQU0sV0FBSSxXQUFXLG9CQUFVLE9BQU8sQ0FBRSxHQUFLLE9BQU8sVUFBRTtTQUM5RDtLQUNGO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2xCO0FBQ0gsQ0FBQztBQUVELE1BQU0sVUFBVSxPQUFPLENBQUMsT0FBZSxFQUFFLE9BQW1CO0lBQW5CLHdCQUFBLEVBQUEsWUFBbUI7SUFDMUQsSUFBSTtRQUNGLElBQUksUUFBUSxFQUFFLEVBQUU7WUFDZCxPQUFPLENBQUMsSUFBSSxPQUFaLE9BQU8saUJBQU0sV0FBSSxXQUFXLG9CQUFVLE9BQU8sQ0FBRSxHQUFLLE9BQU8sVUFBRTtTQUM5RDtLQUNGO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2xCO0FBQ0gsQ0FBQztBQUVELE1BQU0sVUFBVSxRQUFRLENBQUMsT0FBZSxFQUFFLEtBQVc7SUFDbkQsSUFBSTtRQUNGLE9BQU8sQ0FBQyxLQUFLLENBQUMsV0FBSSxXQUFXLHFCQUFXLE9BQU8sQ0FBRSxFQUFFLEtBQUssQ0FBQyxDQUFDO0tBQzNEO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ2pCLFVBQVU7S0FDWDtBQUNILENBQUMifQ==